import React, { useEffect, useState } from "react";
import DTOTransferReceiveARModal from "./DTOTransferReceiveARModal";
import TransferReceiveARModalPresenter from "./TransferReceiveARModalPresenter";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import {
  setAllClaimList,
  setAllClaimListLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimListSlice";
import { claimService } from "../../../../api/services/claimService";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import {
  setAllClaimHistory,
  setClaimTicketLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimHistorySlice";
import { setAllAirTicketHistory } from "../../../../infra/aggregates/myProfile/claimAggregates/airTicketHistorySlice";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
}

const TransferReceiveARModalController = ({
  isModalOpen,
  closeModal,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const { t } = useTranslation();
  const store_claimList: any = useAppSelector(
    (state) => state.claimListSlice.claimList
  );
  const [claimTypes, setClaimTypes] = useState([]);
  const dispatch = useAppDispatch();

  const getData = (data: any) => {
    applyClaim(data);
  };

  const getClaimTypes = (data: any) => {
    setClaimTypes(data);
  };

  async function applyClaim(data: any) {
    if (data.amount > 0 && data.claim_type_id) {
      const empId: any = selector.emp_id;
      const formData = new FormData();

      formData.append("emp_id", empId);
      formData.append("claim_amount", data.amount);
      formData.append("claim_date", data.startDate);
      formData.append("claim_type_id", data.claim_type_id);
      formData.append("remarks", data.remarks);
      formData.append("attachment", data.attachment);

      await claimService
        .applyClaim(formData)
        .then((response: any) => {
          if (response.response == "success") {
            if (response?.data.status == 0) {
              const tempData = [...store_claimList];

              tempData.unshift(response?.data);
              dispatch(setAllClaimList(tempData));
              refreshData();
            }
          }
        })
        .catch((err) => {
          toast.error(
            err?.response?.data?.message || err?.response?.data?.data
          );
        });
    } else {
      toast.error(t("Invalid Data!"));
    }
  }

  const refreshData = async () => {
    dispatch(setClaimTicketLoader(true));
    const res = await claimService.getAllEmployeeClaims(
      selector.emp_id,
      selector.company_id
    );
    if (res) {
      dispatch(setAllClaimList(res?.data));
      dispatch(setAllClaimListLoader(false));
    } else {
      dispatch(setAllClaimListLoader(false));

      return;
    }

    const response = await claimService.getAllClaimHistory(
      selector.emp_id,
      selector.company_id
    );
    if (response) {
      const air_tickets_history = response?.data?.air_tickets;
      const claims_history = response?.data?.claims;

      dispatch(setAllAirTicketHistory(air_tickets_history));
      dispatch(setAllClaimHistory(claims_history));

      dispatch(setClaimTicketLoader(false));
    } else {
      dispatch(setClaimTicketLoader(false));
    }

    closeModal();
  };

  return (
    <div>
      <DTOTransferReceiveARModal setAllClaimTypes={getClaimTypes} />

      <TransferReceiveARModalPresenter
        callBackGetData={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allClaimTypes={claimTypes}
        trans={t}
      />
    </div>
  );
};

export default TransferReceiveARModalController;
